module.exports = __webpack_public_path__ + "static/media/future-tense-table-2.de825461.PNG";